import { Column } from "@bridgesplit/ui";
import { VaultRiskItem } from "@bridgesplit/abf-react";

import { RiskCard } from "./RiskCard";

const SKELETON_COUNT = 3;

export function RiskCardList({ risks }: { risks?: VaultRiskItem[] }) {
    if (!risks) {
        return (
            <Column spacing={1.5}>
                {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                    <RiskCard key={i} />
                ))}
            </Column>
        );
    }

    return (
        <Column spacing={1.5}>
            {risks.map((risk) => (
                <RiskCard key={risk.slug} risk={risk} />
            ))}
        </Column>
    );
}
